import auth from './authReducer';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    auth: auth
})

export default allReducers;